export enum Position {
  Up,
  Down,
  Uptoline,
  Downtoline,
}
